import { render } from "./VehicleReplacementType.vue?vue&type=template&id=67d4f7f9&scoped=true"
import script from "./VehicleReplacementType.vue?vue&type=script&lang=js"
export * from "./VehicleReplacementType.vue?vue&type=script&lang=js"

import "./VehicleReplacementType.vue?vue&type=style&index=0&id=67d4f7f9&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d4f7f9"]])

export default __exports__